import React, { useState } from "react";
import { Link } from "react-router-dom";
import OTPInput from "otp-input-react";

const ValidarEmail = (props) => {
  const [OTP, setOTP] = useState('');
  const [email, setEmail] = useState('');
  const [errorOTP, setErrorOTP] = useState('');
  const [errorEmail, setErrorEmail] = useState('');

  const [initialValue, setInitialValue] = useState(true)
  const handleOTP = () => {
    setInitialValue(false)
    let otpValidate = false;
    let emailValidate = false;

    if (OTP.length === 0) 
    {
      setErrorOTP("O PIN de segurança é obrigatório.");
    }
    else if (OTP.length !== 6) 
    {
      setErrorOTP("PIN de segurança inválido.");
    }
    else {
      setErrorOTP('');
      otpValidate = true;
    }

    if (email.length === 0)
    {
      setErrorEmail("O email é obrigatório.");
    } 
    else if (!/\S+@\S+\.\S+/.test(email))
    {
      setErrorEmail("Email inválido.");
    }
    else {     
      setErrorEmail(''); 
      emailValidate = true;
    }

    if(otpValidate && emailValidate) {      
      props.onSubmitHandler(OTP, email);
    }
  }
  const isButtonEnabled = email != '' && /\S+@\S+\.\S+/.test(email) && OTP.length == 6

  return (
    <div className="mt-5">
      <div className="alert alert-primary border-0 d-flex align-items-center mb-5" role="alert">
        <svg width="16px" height="16px" viewBox="0 0 16 16" className="me-2">
          <g stroke="none" strokeWidth="1" fill="#FFFFFF" fillRule="evenodd">
            <path d="M7.27272727,11.6363636 L8.72727273,11.6363636 L8.72727273,7.27272727 L7.27272727,7.27272727 L7.27272727,11.6363636 Z M8,4.36363636 C8.40218182,4.36363636 8.72727273,4.68872727 8.72727273,5.09090909 C8.72727273,5.49309091 8.40218182,5.81818182 8,5.81818182 C7.59781818,5.81818182 7.27272727,5.49309091 7.27272727,5.09090909 C7.27272727,4.68872727 7.59781818,4.36363636 8,4.36363636 L8,4.36363636 Z M8,16 C12.4109091,16 16,12.4109091 16,8 C16,3.58909091 12.4109091,0 8,0 C3.58909091,0 0,3.58909091 0,8 C0,12.4109091 3.58909091,16 8,16 L8,16 Z" />
          </g>
        </svg>
        <div>
          Verifique o email.<br />
          Foi enviado um PIN de segurança que é válido por 15 minutos.<br />
          Caso não receba um email nos próximos 15 minutos, <Link to="../ajuda" style={{color:'white', textDecoration:'underline'}}>contacte-nos</Link>.
        </div>
      </div>
      <div className="form-group">
        <label>PIN de segurança</label>
        <OTPInput className={"justify-content-md-center " + (errorOTP.length ? 'is-invalid' : '')} inputClassName="form-control" value={OTP} onChange={setOTP} OTPLength={6} otpType="number" secure />
        <div className="invalid-feedback">{errorOTP}</div>
      </div>  
      <br/>
      <div className="form-group">
        <label>Endereço de email</label>
        <input className={"form-control " + (errorEmail.length ? 'is-invalid' : '')} inputClassName="form-control" value={email} onChange={(e)=> setEmail(e.target.value)} type="email" />
        <div className="invalid-feedback">{errorEmail}</div>
        </div> 
      <div className="mt-5">
        <button type="submit" className="btn btn-primary" onClick={() => handleOTP()} disabled={!isButtonEnabled}>
          Continuar
        </button>
        <input type="hidden" className={"form-control " + ((props.errorCode && !errorEmail.length && !errorOTP.length) ? 'is-invalid' : '')}/>
        <div className="invalid-feedback">{props.errorCode} </div>
      </div>
      <p className="mt-5"><a href="#" onClick={props.onNewSubmitHandler}>Pedir novo código de segurança.</a></p>
    </div>
  );
};

export default ValidarEmail;
